import { Trans } from '@lingui/react/macro';
import type { HTMLAttributes } from 'react';

import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

const Empty = ({
  className,
  children = <Trans>No Data Available</Trans>,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      {...rest}
      className={cn('flex flex-row gap-2 w-full h-full p-8 justify-center items-center', className)}
    >
      <Text className="text-center text-gray-500" variant="body1" color="grey">
        {children}
      </Text>
    </div>
  );
};
export default Empty;
